import React, { useState, useEffect, useMemo } from "react";
import Base from "../../Config/Base";
import { Link, useNavigate } from "react-router-dom";
import {
  API_BASE_CRM_URL,
  API_BASE_URL,
  IMAGE_URL_IBIZ,
} from "../../Config/Config";
import Pagination from "../../Config/Pagination";
import "../../../Assets/popup.css";
import "jspdf-autotable";
import "../../Config/loading.css";
import { useLabelContext } from "../../../Context";
import { Footer } from "../footer/footer";
// import { useProductContext } from "../context/productcontext";

export default function Products() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [products, setProducts] = useState([]);
  const [userDataSession, setUserDataSession] = useState({});
  // const { selectProduct } = useProductContext();

  useEffect(() => {
    const userDataString =
      sessionStorage.getItem("MisUserDetails") ||
      localStorage.getItem("MisUserDetails");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const filteredItems = useMemo(() => {
    const results = products.filter((item) =>
      item?.ProductName?.toLowerCase()?.includes(searchTerm?.toLowerCase())
    );
    setCurrentPage(1);

    return results;
  }, [products, searchTerm]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  console.log(userDataSession.OrgId);

  // useEffect(() => {
  //   const fetchProducts = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await fetch(`${API_BASE_URL}MobileSVC/GetProducts`, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           OrgId: userDataSession.OrgId,
  //           Id: "0",
  //           CategoryId: "0",
  //           BarCode: "0",
  //         }),
  //       });

  //       const data = await response.json();
  //       console.log(data);
  //       if (Array.isArray(data.ResultData)) {
  //         setProducts(data.ResultData);
  //         setLoading(false);
  //       } else {
  //         console.error("API response is not an array:", data);
  //         setProducts([]);
  //       }
  //     } catch (error) {
  //       console.error("Error:", error);
  //     }
  //   };
  //   if (userDataSession?.OrgId) {
  //     fetchProducts();
  //   }
  // }, [userDataSession.OrgId]);
  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}Product/GetStoreProducts`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              OrgId: userDataSession.OrgId,
              Id: "0",
              CategoryId: "0",
              BarCode: "0",
              IsActive: 1,
              ProductId: 0,
              StoreId: 0,
              IsForSale: 1,
              UserId: userDataSession.UserId,
              Type: 0,
            }),
          }
        );

        const data = await response.json();
        console.log(data);
        if (Array.isArray(data.ResultData)) {
          setProducts(data.ResultData);
          setLoading(false);
        } else {
          console.error("API response is not an array:", data);
          setProducts([]);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    if (userDataSession?.OrgId) {
      fetchProducts();
    }
  }, [userDataSession.OrgId]);

  //   useEffect(() => {
  //   if (userDataSession && userDataSession.OrgId && userDataSession.UserId) {
  //     setLoading(true);

  //     const requestData = {
  //       OrgId: userDataSession.OrgId,
  //       CategoryId: 0,
  //       BarCode: "0",
  //       IsActive: 1,
  //       ProductId: selectedProduct ? selectedProduct.value : 0,
  //       StoreId: 0,
  //       IsForSale: 1,
  //       UserId: userDataSession.UserId,
  //       Type: 0,
  //     };

  //     Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
  //       .then((response) => {
  //         if (response.data.Status) {
  //           dispatch(set_product_list(response.data.ResultData));
  //           setGetStoreProducts(response.data.ResultData);
  //           console.log(
  //             response.data.ResultData,
  //             "products data getting by default"
  //           );
  //         } else {
  //           console.error("Error fetching data:", response.data.Message);
  //         }
  //         setLoading(false);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching data:", error);
  //         setLoading(false);
  //       });
  //   }
  // }, [dispatch, userDataSession, selectedProduct]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // REPLACED CONTEXT WITH sessionStorage (SIMPLE & NO CONTEXT NEEDED)
  const handleProductClick = (product) => {
    // Save selected product to sessionStorage instead of using context
    sessionStorage.setItem("selectedProduct", JSON.stringify(product));
    navigate("/productdetails");
  };

  return (
    <Base>
      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="page-title me-3">
            <h3>Products</h3>
            <h6>Manage your Products</h6>
          </div>
          <div className="search-bar mb-3 ">
            <div className="input-group">
              <input
                type="text"
                name="search..........."
                placeholder="Search..."
                className="form-control"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="card-container mb-3" style={{ marginTop: "-20px" }}>
          {loading ? (
            <div className="text-center my-5">
              <div className="containers m-auto d-flex justify-content-center align-items-center">
                <div className="dot bg-primary"></div>
                <div className="dot bg-secondary"></div>
                <div className="dot bg-success"></div>
                <div className="dot bg-danger"></div>
                <div className="dot bg-warning"></div>
                <div className="dot bg-info"></div>
              </div>
              <p className="mt-3">Loading...</p>
            </div>
          ) : (
            currentItems &&
            currentItems.map((item, index) => (
              <div
                key={index}
                className="product-card card shadow-lg my-3"
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  transform: "scale(1)",
                  transition: "transform 0.3s ease-in-out",
                  marginTop: "-20px",
                }}
                onClick={() => handleProductClick(item)}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <div
                  className="card-body"
                  style={{
                    padding: "16px",
                  }}
                >
                  <div
                    className="d-flex"
                    style={{
                      alignItems: "flex-start",
                      gap: "20px",
                    }}
                  >
                    {item.ImagePath ? (
                      <img
                        src={`${IMAGE_URL_IBIZ}${item.ImagePath}`}
                        alt="Product"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "12px",
                          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: "80px",
                          height: "80px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "39px",
                          fontWeight: "bold",
                          color: "#ffffff",
                          backgroundColor: "#041243",
                          borderRadius: "12px",
                          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                        }}
                      >
                        {item.ProductName.charAt(0).toUpperCase()}
                      </div>
                    )}
                    <div>
                      <b
                        className=""
                        style={{
                          color: "#007bff",
                        }}
                      >
                        {item.ProductName}
                      </b>
                      <div
                        className="d-flex align-items-center"
                        style={{
                          fontSize: "14px",
                        }}
                      >
                        <i
                          className="fa-solid fa-table-columns"
                          style={{
                            marginRight: "8px",
                            color: "#007bff",
                          }}
                        ></i>
                        {item.CategoryName}
                      </div>
                      {/* <div style={{
                        fontSize: '14px',
                      }}>
                        <i className="fa-solid fa-barcode" style={{
                          color: '#007bff',
                          marginRight: '8px',
                        }}></i>
                        {item.BarCode || 'N/A'}
                      </div> */}
                      <div
                        style={{
                          fontSize: "16px",
                        }}
                      >
                        <i
                          className="fa-solid fa-indian-rupee-sign"
                          style={{
                            color: "#007bff",
                            marginRight: "8px",
                          }}
                        ></i>
                        {item.MRP}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredItems.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </div>
      <br></br>
      <br></br>
      <br></br>
      <Footer></Footer>
    </Base>
  );
}